export enum CSVImportType {
  shopify,
  woocommerce,
  squarespace,
}
